import { Position } from '../../models/Position';
import { changeColumnNumber } from '../../common/helpers/positionComputer';
import { refPadding } from '../../services/helpers/print/constants';
import { IWidget } from '../../widgets';
import { PageProperties } from './PageProperties';
import { ScaledPage } from './ScaledPage';

export function buildPages(widgets: IWidget[], pageProperties: PageProperties): ScaledPage[] {
    const pages: ScaledPage[] = [];
    let page: ScaledPage = {
        widgets: [],
        classed: {
        },
        properties: pageProperties
    };
    pages.push(page);
    if (widgets && widgets.length) {
        let offset = 0;
        const pageHeight = pageProperties.height;
        const padding = refPadding * pageProperties.ratio;
        const positionedWidgets = changeColumnNumber<IWidget & {printPosition?: Position}>(widgets, pageProperties.nColumns);
        positionedWidgets
            .forEach(w => {
                const width = (w.printPosition.sizeX * pageProperties.colWidth) - padding;
                const x = (w.printPosition.col ?? 0) * pageProperties.colWidth + padding;

                // Page jump handling
                // Worked before, still works, but seems too magic
                const height = (w.printPosition.sizeY * pageProperties.rowHeight) - padding;
                let y = (w.printPosition.row ?? 0) * pageProperties.rowHeight - offset;
                if (y >= pageHeight || ((y + height) > pageHeight && height <= pageHeight)) {
                    page = {
                        widgets: [],
                        classed: {
                        }, 
                        properties: pageProperties
                    };
                    pages.push(page);
                    offset += y;
                    y = 0;
                }
                y += padding;

                const toAdd = {
                    style: {
                        height: `${Math.round(height)}px`,
                        width: `${Math.round(width)}px`,
                        left: `${Math.round(x)}px`,
                        top: `${Math.round(y)}px`
                    },
                    item: w
                };
                page.widgets.push(toAdd);
            });
    }
    return pages;
}